export default "__VITE_ASSET__D$URqXHm__"